import React from 'react';
import './sessao.component.scss';
import SiteModel, { ComponentsModel } from '../../models/layout.model';
import MenuModel from '../../models/menu.model';
import { CONSTANTS } from '../../constants/constants';
import { Button } from '@mui/material';
import { NavLink } from 'react-router-dom';

export type SessaoComponentProps = {
  itemSite: ComponentsModel;
  menu?: MenuModel;
}

function SessaoComponent(props: SessaoComponentProps) {

  return (
    <section
      id={props.itemSite.sessao?.id}
      className={"sessao " + 'is-full-' + props.itemSite.sessao?.full}
      style={props.itemSite.sessao?.bg ? { backgroundColor: props.itemSite.sessao?.bg } : { backgroundColor: '#fff' }}
    >
      <div className="container">
        {
          props.itemSite.sessao?.layout === CONSTANTS.LAYOUT_SESSAO.IMG_DIR &&
          <div className="flex reverse-mobile">
            <div className="esq" style={props.itemSite.sessao?.bg ? { backgroundColor: props.itemSite.sessao?.bg } : { backgroundColor: '#fff' }}>
            <h2
                style={{
                  color: props.itemSite.sessao?.cor_do_titulo ? props.itemSite.sessao?.cor_do_titulo : '#333',
                  textAlign: props.itemSite.sessao?.alinhamento_titulo ? props.itemSite.sessao?.alinhamento_titulo : 'left',
                }}
              >{props.itemSite.sessao?.titulo}</h2>
              <div
                className='txt'
                style={{
                  color: props.itemSite.sessao?.cor_do_texto ? props.itemSite.sessao?.cor_do_texto : '#333',
                  textAlign: props.itemSite.sessao?.alinhamento_descricao ? props.itemSite.sessao?.alinhamento_descricao : 'left',
                }}
                dangerouslySetInnerHTML={{ __html: props.itemSite.sessao?.descricao.replaceAll('[iframe', '<iframe').replaceAll('iframe]', 'iframe>') }}
              ></div>
              {
                props.itemSite.sessao?.texto_botao &&
                <>
                  {
                    props.itemSite.sessao?.tipo_botao === CONSTANTS.TIPO_BOTAO.LINK_EXTERNO ?
                      <Button
                        href={props.itemSite.sessao?.url_botao} target='_blank'
                        style={{
                          color: props.itemSite.sessao?.cor_texto_botao ? props.itemSite.sessao?.cor_texto_botao : "#fff",
                          backgroundColor: props.itemSite.sessao?.cor_bg_botao ? props.itemSite.sessao?.cor_bg_botao : "#333"
                        }}
                      >
                        {props.itemSite.sessao?.texto_botao}
                      </Button>
                      :
                      <>
                        {
                          props.menu?.tipo_menu === CONSTANTS.TIPO_MENU.SCROLL ?
                            <Button
                              href={CONSTANTS.TIPO_MENU.SCROLL + props.itemSite.sessao?.url_botao}
                              style={{
                                color: props.itemSite.sessao?.cor_texto_botao ? props.itemSite.sessao?.cor_texto_botao : "#fff",
                                backgroundColor: props.itemSite.sessao?.cor_bg_botao ? props.itemSite.sessao?.cor_bg_botao : "#333"
                              }}
                            >
                              {props.itemSite.sessao?.texto_botao}
                            </Button>
                            :
                            <NavLink exact={true} to={CONSTANTS.TIPO_MENU.NOVA_PAGINA + props.itemSite.sessao?.url_botao}>
                              <Button
                                style={{
                                  color: props.itemSite.sessao?.cor_texto_botao ? props.itemSite.sessao?.cor_texto_botao : "#fff",
                                  backgroundColor: props.itemSite.sessao?.cor_bg_botao ? props.itemSite.sessao?.cor_bg_botao : "#333"
                                }}
                              >{props.itemSite.sessao?.texto_botao}</Button>
                            </NavLink>
                        }
                      </>
                  }
                </>
              }
            </div>
            <div className="dir has-img">
              <img src={props.itemSite.sessao?.imagem} alt={props.itemSite.sessao?.titulo} />
            </div>
          </div>
        }

        {
          props.itemSite.sessao?.layout === CONSTANTS.LAYOUT_SESSAO.IMG_ESQ &&
          <div className="flex">
            <div className="esq has-img">
              <img src={props.itemSite.sessao?.imagem} alt={props.itemSite.sessao?.titulo} />
            </div>
            <div className="dir" style={props.itemSite.sessao?.bg ? { backgroundColor: props.itemSite.sessao?.bg } : { backgroundColor: '#fff' }}>
              <h2
                style={{
                  color: props.itemSite.sessao?.cor_do_titulo ? props.itemSite.sessao?.cor_do_titulo : '#333',
                  textAlign: props.itemSite.sessao?.alinhamento_titulo ? props.itemSite.sessao?.alinhamento_titulo : 'left',
                }}
              >{props.itemSite.sessao?.titulo}</h2>
              <div
                className='txt'
                style={{
                  color: props.itemSite.sessao?.cor_do_texto ? props.itemSite.sessao?.cor_do_texto : '#333',
                  textAlign: props.itemSite.sessao?.alinhamento_descricao ? props.itemSite.sessao?.alinhamento_descricao : 'left',
                }}
                dangerouslySetInnerHTML={{ __html: props.itemSite.sessao?.descricao.replaceAll('[iframe', '<iframe').replaceAll('iframe]', 'iframe>') }}
              ></div>
              {
                props.itemSite.sessao?.texto_botao &&
                <>
                  {
                    props.itemSite.sessao?.tipo_botao === CONSTANTS.TIPO_BOTAO.LINK_EXTERNO ?
                      <Button
                        href={props.itemSite.sessao?.url_botao} target='_blank'
                        style={{
                          color: props.itemSite.sessao?.cor_texto_botao ? props.itemSite.sessao?.cor_texto_botao : "#fff",
                          backgroundColor: props.itemSite.sessao?.cor_bg_botao ? props.itemSite.sessao?.cor_bg_botao : "#333"
                        }}
                      >
                        {props.itemSite.sessao?.texto_botao}
                      </Button>
                      :
                      <>
                        {
                          props.menu?.tipo_menu === CONSTANTS.TIPO_MENU.SCROLL ?
                            <Button
                              href={CONSTANTS.TIPO_MENU.SCROLL + props.itemSite.sessao?.url_botao}
                              style={{
                                color: props.itemSite.sessao?.cor_texto_botao ? props.itemSite.sessao?.cor_texto_botao : "#fff",
                                backgroundColor: props.itemSite.sessao?.cor_bg_botao ? props.itemSite.sessao?.cor_bg_botao : "#333"
                              }}
                            >
                              {props.itemSite.sessao?.texto_botao}
                            </Button>
                            :
                            <NavLink exact={true} to={CONSTANTS.TIPO_MENU.NOVA_PAGINA + props.itemSite.sessao?.url_botao}>
                              <Button
                                style={{
                                  color: props.itemSite.sessao?.cor_texto_botao ? props.itemSite.sessao?.cor_texto_botao : "#fff",
                                  backgroundColor: props.itemSite.sessao?.cor_bg_botao ? props.itemSite.sessao?.cor_bg_botao : "#333"
                                }}
                              >{props.itemSite.sessao?.texto_botao}</Button>
                            </NavLink>
                        }
                      </>
                  }
                </>
              }
            </div>
          </div>
        }

        {
          props.itemSite.sessao?.layout === CONSTANTS.LAYOUT_SESSAO.APENAS_TEXTO &&
          <div className="flex">
            <div className="box-texto" style={props.itemSite.sessao?.bg ? { backgroundColor: props.itemSite.sessao?.bg } : { backgroundColor: '#fff' }}>
              <h2
                style={{
                  color: props.itemSite.sessao?.cor_do_titulo ? props.itemSite.sessao?.cor_do_titulo : '#333',
                  textAlign: props.itemSite.sessao?.alinhamento_titulo ? props.itemSite.sessao?.alinhamento_titulo : 'left',
                }}
              >{props.itemSite.sessao?.titulo}</h2>
              <div
                className='txt'
                style={{
                  color: props.itemSite.sessao?.cor_do_texto ? props.itemSite.sessao?.cor_do_texto : '#333',
                  textAlign: props.itemSite.sessao?.alinhamento_descricao ? props.itemSite.sessao?.alinhamento_descricao : 'left',
                }}
                dangerouslySetInnerHTML={{ __html: props.itemSite.sessao?.descricao.replaceAll('[iframe', '<iframe').replaceAll('iframe]', 'iframe>') }}
              ></div>
              {
                props.itemSite.sessao?.texto_botao &&
                <>
                  {
                    props.itemSite.sessao?.tipo_botao === CONSTANTS.TIPO_BOTAO.LINK_EXTERNO ?
                      <Button
                        href={props.itemSite.sessao?.url_botao} target='_blank'
                        style={{
                          color: props.itemSite.sessao?.cor_texto_botao ? props.itemSite.sessao?.cor_texto_botao : "#fff",
                          backgroundColor: props.itemSite.sessao?.cor_bg_botao ? props.itemSite.sessao?.cor_bg_botao : "#333"
                        }}
                      >
                        {props.itemSite.sessao?.texto_botao}
                      </Button>
                      :
                      <>
                        {
                          props.menu?.tipo_menu === CONSTANTS.TIPO_MENU.SCROLL ?
                            <Button
                              href={CONSTANTS.TIPO_MENU.SCROLL + props.itemSite.sessao?.url_botao}
                              style={{
                                color: props.itemSite.sessao?.cor_texto_botao ? props.itemSite.sessao?.cor_texto_botao : "#fff",
                                backgroundColor: props.itemSite.sessao?.cor_bg_botao ? props.itemSite.sessao?.cor_bg_botao : "#333"
                              }}
                            >
                              {props.itemSite.sessao?.texto_botao}
                            </Button>
                            :
                            <NavLink exact={true} to={CONSTANTS.TIPO_MENU.NOVA_PAGINA + props.itemSite.sessao?.url_botao}>
                              <Button
                                style={{
                                  color: props.itemSite.sessao?.cor_texto_botao ? props.itemSite.sessao?.cor_texto_botao : "#fff",
                                  backgroundColor: props.itemSite.sessao?.cor_bg_botao ? props.itemSite.sessao?.cor_bg_botao : "#333"
                                }}
                              >{props.itemSite.sessao?.texto_botao}</Button>
                            </NavLink>
                        }
                      </>
                  }
                </>
              }
            </div>
          </div>
        }
      </div>
    </section>
  );
}

export default SessaoComponent;
